import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
} from "reactstrap";
import { FiNavigation2 } from "react-icons/fi";
import { HiOutlineLocationMarker } from "react-icons/hi";
// import { BsChevronRight } from "react-icons/bs";

import "../../pages/MyRoutes/Detail/Routes_Detail.scss";

function AddPointsModal({
  showAddPointModal,
  toggleAddPoint,
  PointAboveDetail,
  addPointsDetail,
}) {
  const navigate = useNavigate();

  const handleAbovePoint = () => {
    if (PointAboveDetail?.[0]?.key === "addPointAbove") {
      navigate("/along-route", { state: { data: PointAboveDetail } });
    } else if (addPointsDetail?.[0].key === "addPoints") {
      navigate("/along-route", { state: { data: addPointsDetail } });
    } else {
      navigate("/along-route");
    }
  };

  const handleAboveOfAddMorePoints = () => {
    if (PointAboveDetail?.[0]?.key === "addPointAbove") {
      navigate("/add-more-points-to-route", {
        state: { data: PointAboveDetail },
      });
    } else if (addPointsDetail?.[0].key === "addPoints") {
      navigate("/add-more-points-to-route", {
        state: { data: addPointsDetail },
      });
    } else {
      navigate("/add-more-points-to-route");
    }
  };

  const handleAbovePointCustomAddress = () => {
    if (PointAboveDetail?.[0]?.key === "addPointAbove") {
      navigate("/search-custom-point", { state: { data: PointAboveDetail } });
    }
    if (
      Array.isArray(addPointsDetail) &&
      addPointsDetail[0]?.key === "addPoints"
    ) {
      navigate("/search-custom-point", { state: { data: addPointsDetail } });
    } else {
      navigate("/search-custom-point");
    }
  };

  return (
    <Modal
      className="add_points modal-dialog-centered"
      isOpen={showAddPointModal}
      toggle={toggleAddPoint}
    >
      <ModalHeader>Add Points</ModalHeader>
      <ModalBody>
        <Form className="add_points_form">
          <FormGroup className="addpoints_route">
            <Button onClick={handleAboveOfAddMorePoints} className="btn">
              + Add more points to route
            </Button>
          </FormGroup>
          <FormGroup className="findpoints_route">
            <Button onClick={handleAbovePoint} className="btn">
              <div className="button_text">
                <FiNavigation2 size={17} className="navigation_icon" />
                &nbsp;Find points along route{" "}
              </div>
            </Button>
          </FormGroup>
          <FormGroup className="findpoints_route">
            <Button onClick={handleAbovePointCustomAddress} className="btn">
              <div className="button_text">
                <HiOutlineLocationMarker size={17} className="location_icon" />
                &nbsp; &nbsp;Enter custom address
              </div>
            </Button>
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
}

export default AddPointsModal;
